import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_adminLayout/admin/parts/categories")({
  component: () => <Outlet />,
});
